var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"control-hint control-hint--variant_1",class:_vm.classes},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }